import React from "react";
import Particles from "react-tsparticles";

function Particle() {
  return (
    <Particles
      id="tsparticles"
      params={{
        particles: {
          number: {
            value: 80,
            density: { enable: true, value_area: 800 },
          },
          color: { value: ["#a855f7", "#22d3ee", "#c084fc"] },
          shape: { type: "circle" },
          opacity: {
            value: 0.4,
            random: true,
            anim: { enable: true, speed: 0.8, opacity_min: 0.05 },
          },
          size: {
            value: 2,
            random: true,
            anim: { enable: true, speed: 2, size_min: 0.5 },
          },
          line_linked: {
            enable: true,
            distance: 150,
            color: "#a855f7",
            opacity: 0.08,
            width: 1,
          },
          move: {
            enable: true,
            speed: 0.6,
            direction: "none",
            random: true,
            straight: false,
            out_mode: "out",
          },
        },
        interactivity: {
          detect_on: "canvas",
          events: {
            onhover: { enable: true, mode: "grab" },
            onclick: { enable: true, mode: "push" },
            resize: true,
          },
          modes: {
            grab: { distance: 140, line_linked: { opacity: 0.2 } },
            push: { particles_nb: 3 },
          },
        },
        retina_detect: true,
      }}
    />
  );
}

export default Particle;
